<template>
  <div class="home-container">
    <!-- 背景图 -->
    <div
      class="background-image"
      :style="{ backgroundImage: `url(${currentBackground})` }"
    ></div>

    <!-- 内容区域 -->
    <div class="content-area" v-if="currentSlide !== null">
      <p>{{ slides[currentSlide].description }}</p>
      
      <!-- 普通按钮 -->
      <router-link 
        v-if="slides[currentSlide].buttonText && slides[currentSlide].link && !slides[currentSlide].isExternal && !slides[currentSlide].socialButtons" 
        :to="slides[currentSlide].link" 
        class="action-btn"
      >
        {{ slides[currentSlide].buttonText }}
      </router-link>
      <a 
        v-else-if="slides[currentSlide].buttonText && slides[currentSlide].link && slides[currentSlide].isExternal && !slides[currentSlide].socialButtons" 
        :href="slides[currentSlide].link" 
        target="_blank" 
        class="action-btn"
      >
        {{ slides[currentSlide].buttonText }}
      </a>
      
      <!-- 社交媒体按钮 -->
      <div v-if="slides[currentSlide].socialButtons" class="social-buttons">
        <a 
          v-for="(button, index) in slides[currentSlide].socialButtons" 
          :key="index"
          :href="button.link" 
          target="_blank" 
          class="social-btn"
        >
          <img :src="button.icon" :alt="button.text" class="social-icon">
        </a>
      </div>
    </div>

    <!-- 滚动文字导航 -->
    <div class="marquee-navigation">
      <div class="marquee-container">
        <div class="marquee-content">
          <span
            v-for="(slide, index) in slides"
            :key="'first-'+index"
            class="marquee-item"
            :class="{ 'active': currentSlide === index }"
            @click="setBackground(index)"
          >
            {{ slide.title }}
          </span>
          <!-- 复制一份相同的内容以实现无缝循环 -->
          <span
            v-for="(slide, index) in slides"
            :key="'second-'+index"
            class="marquee-item"
            :class="{ 'active': currentSlide === index }"
            @click="setBackground(index)"
          >
            {{ slide.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      currentSlide: 0,
      currentBackground: '',
      isMobile: false,
      slides: []
    }
  },
  created() {
    this.initSlides();
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
    this.updateCurrentBackground();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    initSlides() {
      try {
        this.slides = [
          {
            title: '主視覺',
            // description: '探索艺术的无限可能',
            webBg: require('@/assets/images/home/image1_home.png'),
            mobileBg: require('@/assets/images/home/image1_mh.png'),
            link: '/main-vision',
            // 移除了buttonText
          },
          {
            title: '時間地點',
            // description: '2023年6月15日至7月30日，藝術中心主展廳',
            webBg: require('@/assets/images/home/image2_time.png'),
            mobileBg: require('@/assets/images/home/image2_mt.png'),
            link: '/venue',
            // 移除了buttonText: '查看地圖'
          },
          {
            title: '參展人',
            // description: '來自世界各地的知名藝術家',
            webBg: require('@/assets/images/home/image3_artist.png'),
            mobileBg: require('@/assets/images/home/image3_ma.png'),
            link: '/artists',
            // 移除了buttonText: '認識藝術家'
          },
          {
            title: '作品體驗預約',
            // description: '預約專屬導覽，深入了解藝術作品',
            webBg: require('@/assets/images/home/image4_reserve.png'),
            mobileBg: require('@/assets/images/home/image4_mr.png'),
            link: 'https://calendar.google.com/calendar/u/0/appointments/AcZssZ3IJ5aLJPKN2wEFgjPU3ov30hh68pmBmWzypfM=',
            buttonText: '立即預約',
            isExternal: true
          },
          {
            title: '表演場次公告',
            // description: '查看最新表演日程安排',
            webBg: require('@/assets/images/home/image5_per.png'),
            mobileBg: require('@/assets/images/home/image5_mp.png'),
            link: '/performances',
            
          },
          {
            title: '聯絡我們',
            // description: '有任何問題，請隨時聯絡我們',
            webBg: require('@/assets/images/home/image6_contact.png'),
            mobileBg: require('@/assets/images/home/image6_mc.png'),
            link: '/contact',
            socialButtons: [
              {
                text: 'Instagram',
                link: 'https://www.instagram.com/all.ipta/?igsh=MTJqZnZyMXU0bTNhdA%3D%3D&utm_source=qr#',
                icon: require('@/assets/images/home/ig.jpg')
              },
              {
                text: 'Facebook',
                link: 'https://www.facebook.com/atall.ipta?mibextid=wwXIfr&rdid=Je8AvdW7ymjNoh7j&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14EkZoFoRux%2F%3Fmibextid%3DwwXIfr#',
                icon: require('@/assets/images/home/fb.png')
              }
            ]
          }
        ];
        console.log('Slides initialized:', this.slides.length);
        
        // 确保初始化后设置当前背景
        if (this.slides.length > 0) {
          this.updateCurrentBackground();
        }
      } catch (error) {
        console.error('Error initializing slides:', error);
        this.slides = [];
      }
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
      this.updateCurrentBackground();
    },
    setBackground(index) {
      if (index >= 0 && index < this.slides.length) {
        this.currentSlide = index;
        this.updateCurrentBackground();
      }
    },
    updateCurrentBackground() {
      if (this.slides.length > 0 && this.currentSlide !== null) {
        const currentSlide = this.slides[this.currentSlide];
        this.currentBackground = this.isMobile ? currentSlide.mobileBg : currentSlide.webBg;
        console.log('Current background set to:', this.currentBackground);
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  position: relative;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: background-image 0.5s ease-in-out;
}

.content-area {
  position: absolute;
  bottom: 280px;
  left: 50%;
  transform: translateX(-50%);
  color: #004D6B;
  max-width: 500px;
  text-align: center;
  text-shadow: 1px 1px 3px rgba(255, 255, 255, 0.5);
  z-index: 10;
}

.content-area p {
  font-size: 18px;
  margin-bottom: 20px;
  color: #004D6B;
}

.action-btn {
  display: inline-block;
  background-color: rgba(240, 131, 30);
  color: white;
  padding: 10px 25px;
  border-radius: 30px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.action-btn:hover {
  background-color: rgba(240, 131, 30);
  color: white;
}

/* 滚动文字导航样式 */
.marquee-navigation {
  position: absolute;
  bottom: 80px;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 80px;
  z-index: 20;
}

.marquee-container {
  width: 100%;
  overflow: hidden;
}

.marquee-content {
  display: inline-block;
  white-space: nowrap;
  animation: marquee 30s linear infinite;
}

.marquee-item {
  display: inline-block;
  margin: 0 80px;
  color: #004D6B;
  font-size: 40px;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

.marquee-item:hover {
  color: rgba(240, 131, 30);
  text-shadow: 2px 2px 8px rgba(255, 255, 255, 0.8),
               -1px -1px 4px rgba(255, 255, 255, 0.6);
}

.marquee-item.active {
  color: rgba(240, 131, 30);
  transform: scale(1.1);
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 768px) {
  .content-area {
    bottom: 220px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 80%;
    text-align: center;
  }
  
  .content-area p {
    font-size: 16px;
  }
  
  .marquee-item {
    font-size: 24px;
    margin: 0 30px;
  }
  
  .marquee-navigation {
    bottom: 40px;
  }
}

.social-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 15px;
}

.social-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  background-color: white;
  color: white;
  border-radius: 15px;
  font-weight: bold;
  transition: all 0.3s;
  text-decoration: none;
  box-shadow: 
    4px 4px 8px rgba(0, 0, 0, 0.3),
    -2px -2px 6px rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
}

.social-icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.social-btn:hover {
  background-color: rgba(240, 131, 30, 0.9);
  transform: translateY(-2px);
  box-shadow: 
    6px 6px 10px rgba(0, 0, 0, 0.4),
    -3px -3px 8px rgba(255, 255, 255, 0.9);
}

.social-btn:active {
  transform: translateY(1px);
  box-shadow: 
    2px 2px 4px rgba(0, 0, 0, 0.2),
    -1px -1px 3px rgba(255, 255, 255, 0.7);
}
</style>

